export const styles = () => ({
  breadcrumb: {
    marginBottom: 10,
  },
});
